import React, { MouseEvent, useEffect, useState } from 'react';
import { Button, styled, Typography } from '@mui/material';
import { Inventory2Outlined } from '@mui/icons-material';
import Dialog from 'components/dialogs/Dialog';
import PackagesAutoComplete from 'components/autocomplete/PackagesAutoComplete';
import { toast } from 'react-toastify';
import { Package } from 'types/package';
import { ProcedurePackage } from 'types/procedure';

interface ProcedurePackageFormProps {
  onExited: () => void;
  handleAddPackage: (packageInfo: ProcedurePackage | null) => void;
  packageInfo: ProcedurePackage | null;
  handleChangePackageInfo(index: keyof ProcedurePackage, value: any): void;
  type: 'new' | 'edit';
}

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
});

const Intro = styled('div')({
  border: '1px solid #eadde1',
  borderRadius: 8,
  padding: 12,
  background: 'linear-gradient(135deg, #fff7fa 0%, #fff 100%)',
  display: 'flex',
  gap: 10,
  alignItems: 'center',
});

const IconBox = styled('div')({
  width: 34,
  height: 34,
  borderRadius: 8,
  background: '#fff4f7',
  color: '#7b1235',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
});

const DialogActions = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
  paddingTop: 4,
});

const ProcedurePackageForm: React.FC<ProcedurePackageFormProps> = ({
  handleAddPackage,
  onExited,
  packageInfo,
  handleChangePackageInfo,
  type,
}) => {
  const [pkg, setPkg] = useState<Package | null>(null);

  useEffect(() => {
    setPkg(packageInfo?.package || null);
  }, [packageInfo]);

  function handleValidation(e?: MouseEvent<HTMLButtonElement>) {
    e?.preventDefault();

    if (!pkg || !packageInfo?.package_id) {
      toast.error('Selecione um pacote');
      return;
    }

    handleAddPackage({
      ...packageInfo,
      package: pkg,
      package_id: pkg.id,
    });
  }

  return (
    <Dialog
      onExited={onExited}
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth="sm"
      title={type === 'edit' ? 'Editar pacote' : 'Adicionar pacote'}
    >
      <Container>
        <Intro>
          <IconBox>
            <Inventory2Outlined fontSize="small" />
          </IconBox>
          <div>
            <Typography variant="body2" fontWeight={800}>
              Pacote sugerido
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Escolha o pacote que será sugerido neste procedimento.
            </Typography>
          </div>
        </Intro>

        <PackagesAutoComplete
          label="Pacote"
          onSelect={pkg => {
            handleChangePackageInfo('package_id', pkg?.id || '');
            handleChangePackageInfo('package', pkg);
            setPkg(pkg);
          }}
          placeholder="Selecione um pacote"
          selected={pkg}
        />

        <DialogActions>
          <Button variant="outlined" color="primary" onClick={onExited}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={handleValidation}>
            {type === 'new' ? 'Adicionar' : 'Salvar'}
          </Button>
        </DialogActions>
      </Container>
    </Dialog>
  );
};

export default ProcedurePackageForm;
